import { connect } from "react-redux";
import { PlusIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import Button from "src/components/Shared/Buttons/Button";
import Search from "src/components/Shared/Search";
import MultiColumnLayout from "src/components/Shared/MultiColumnLayout/MultiColumnLayout";
import useGetListAndSelectItem from "src/hooks/useGetListAndSelectItem";
import PlanItems from "./PlanItems";
import PlanBodyContent from "./PlanBodyContent";
import PlanManageModal from "../Modal/PlanManageModal";
import Modal from "src/components/Shared/Modal";
import { apiRequest } from "src/async/apiUtils";
import { toast } from "react-toastify";
import SelectMenu from "src/components/Shared/Forms/Selects/SelectMenu";

const PlanList = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedAssignPlan, setSelectedAssignPlan] = useState(null);

  const { lists, setLists, meta, isLoaded, limit, offset, setOffset, keyword, setKeyword, selectedItem, setSelectedItem, refreshData, handleOnPaginationChange } = useGetListAndSelectItem({
    url: `/plans`,
    paginationData: { limit: 10, offset: 0 },
  });

  const onOpenEditModal = () => {
    setEditItem(selectedItem);
    setIsAddModalOpen(true);
  };

  const handleOnDelete = async () => {
    try {
      setIsDeleting(true);
      const queries = { assign_plan_id: selectedAssignPlan };
      const params = { plan_id: selectedItem?._id };
      const { data } = await apiRequest("DELETE", `/plans/:plan_id`, { params, queries });
      setDeleteModalIsOpen(false);
      refreshData();
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsDeleting(false);
    }
  };

  const headerActions = [
    { name: "Edit", onClick: onOpenEditModal },
    { name: "", type: "hr" },
    { name: "Delete", onClick: () => setDeleteModalIsOpen(true) },
  ];

  return (
    <>
      <MultiColumnLayout
        subTitle={`Total of ${meta?.count || 0} plans`}
        asideLoaded={isLoaded}
        aside={lists}
        paginationData={{ meta, limit, offset }}
        handleOnPaginationChange={handleOnPaginationChange}
        itemEntry={(item) => <PlanItems data={item} />}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        mainHeaderContent={
          <>
            <div className="w-96">
              <Search
                keyword={keyword}
                setKeyword={(val) => {
                  setOffset(0);
                  setKeyword(val);
                }}
                placeholder={"Search"}
                inline={true}
              />
            </div>
            <div className="relative">
              <Button
                version="secondary"
                onClick={() => {
                  setEditItem(null);
                  setIsAddModalOpen(true);
                }}>
                <PlusIcon className="h-5 w-5" />
                Add plan
              </Button>
            </div>
          </>
        }
        bodyHeaderActions={headerActions}
        bodyContent={
          <PlanBodyContent
            data={selectedItem}
            setLists={setLists}
            setSelectedItem={setSelectedItem}
          />
        }
      />
      <PlanManageModal
        title={!editItem ? "Add Plan" : "Edit Plan"}
        isOpen={isAddModalOpen}
        editItem={editItem}
        onSuccess={() => {
          setIsAddModalOpen(false);
          refreshData();
        }}
        onCancel={() => setIsAddModalOpen(false)}
      />
      <Modal
        title="Plan"
        secondaryTitle="Delete"
        isOpen={deleteModalIsOpen}
        onCancel={() => setDeleteModalIsOpen(false)}
        isLoading={isDeleting}
        onSuccess={handleOnDelete}
        defaultOptions={{
          onSuccessButtonText: "Delete",
        }}>
        {selectedItem?.client_count > 0 ? (
          <>
            <div className="text-sm">
              This plan is being used by <span className="font-semibold text-highlightColor">{selectedItem?.workspaces} workspace(s) </span>, If you still want to delete you have assign a new plan to those workspace.
            </div>
            <div className="relative my-2 w-1/2">
              <SelectMenu
                label="Assign a new plan"
                inline={true}
                startIndex={-1}
                value={lists?.find((item) => item._id === selectedAssignPlan) ? { key: lists.find((item) => item._id === selectedAssignPlan)?.name, value: selectedAssignPlan } : { key: "Select an option", value: -1 }}
                options={lists?.filter((item) => item?._id !== selectedItem?._id)?.map((pln) => ({ key: pln?.name, value: pln?._id }))}
                setOption={(option) => setSelectedAssignPlan(option.value)}
              />
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-y-1 whitespace-nowrap p-3 text-gray-600">
            <p className="text-lg">
              Are you sure you want to <span className="px-1 font-semibold text-gray-700">DELETE</span>
              this plan?
            </p>
            <div className="text-gray-400">Once you delete this plan it's gone for good.</div>
          </div>
        )}
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(PlanList);
